<template>
    <button :type="type"
            class="px-4 py-2 flex items-center justify-center text-lg leading-5 rounded-md text-white border border-transparent focus:outline-none focus:shadow-none disabled:opacity-25 transition transition-all duration-150"
            :class="bgDark ? 'bg-dark hover:bg-darkh' : 'bg-red-0 hover:bg-red-0h'"
    >
        <slot></slot>
        <svg v-if="hasIcon" class="w-3 h-3.5 ml-2" fill="white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <path d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"/>
        </svg>
    </button>
</template>

<script>
    import { defineComponent } from 'vue'

    export default defineComponent({
        props: {
            type: {
                type: String,
                default: 'submit',
            },
            hasIcon: {
                hasIcon: Boolean,
                default: false
            },
            bgDark: {
                bgDark: Boolean,
                default: false
            }
        }
    })
</script>
